/* eslint-disable react-hooks/exhaustive-deps */
// Libraries
import { setEntityDataSuccess } from 'containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import {
    fetchEntityHierarchyRequest,
    fetchEntityListRequest,
} from 'containers/MerchantOnboard/redux/merchantOnBoard.actions';

import React, {
    useMemo,
    useState,
    useCallback,
    useEffect,
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

// Layouts

// Components

// Constants

// Actions

// Styles
import './transactions.scss';
import { raiseChargeBackRequest } from 'containers/Chargeback/redux/chargeback.actions';
import {
    ADMIN_ONLY_TRANSACTION_TYPE,
    ENTITY_TYPE,
    TRANSACTION_TYPE,
} from '../../utils/constants/commonValues';
import {
    Table,
    TableFilter,
    Popup,
    TransactionForm,
    ViewDownloadStatus,
    TableSearch,
    FormElems,
} from '../../components';
import { PAYMENT_MODE } from './constant';
import {
    fetchTransactionsRequest,
    generateReportRequest,
    generateReportError,
    fetchTransactionsStatusRequest,
    fetchTransactionsStatusError,
    getRefundTxnRequest,
    resetRefunTxn,
} from './redux/transactions.actions';
import DownloadFile from './DownloadFile';

let filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment()
                .endOf('day')
                .subtract(1, 'days'),
            endDate: moment().endOf('day'),
            maximumNights: 30,
            notResetDate: true,
        },
    },

    {
        fieldType: 'search-select',
        label: 'Aggregator Name',
        name: 'aggregatorId',
        props: {
            data: [],
            label: 'Select Aggregator',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'AGGREGATOR',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant Name',
        name: 'merchantName',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'MERCHANT_NAME',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant ID',
        name: 'merchantId',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'entityCode',
            valueField: 'entityCode',
            entityType: 'MERCHANT',
        },
    },

    {
        fieldType: 'parallel-input',
        label: 'Amount',
        fieldA: {
            name: 'minAmt',
            props: {
                placeholder: 'Min. Amount',
                type: 'number',
            },
        },
        fieldB: {
            name: 'maxAmt',
            props: {
                placeholder: 'Max. Amount',
                type: 'number',
            },
        },
    },
    {
        fieldType: 'search-select',
        label: 'Transaction Mode',
        name: 'transactionModes',
        props: {
            data: PAYMENT_MODE,
            label: 'Select Payment Mode',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'checkbox',
        label: 'Transaction Type',
        name: 'transactionTypes',
        props: {
            options: (() => {
                const options = [];
                for (const key in TRANSACTION_TYPE) {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            TRANSACTION_TYPE,
                            key
                        )
                    ) {
                        const value = TRANSACTION_TYPE[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'checkbox',
        label: 'Transaction Status',
        name: 'transactionStates',
        props: {
            options: [
                {
                    name: 'Success',
                    value: 'SUCCESS',
                },
                {
                    name: 'Failed',
                    value: 'FAILED',
                },
                {
                    name: 'Pending',
                    value: 'PENDING',
                },
            ],
            labelField: 'name',
            valueField: 'value',
        },
    },
];

const searchKeyList = [
    {
        name: 'FCPG TXN ID',
        value: 'TRANSACTION_ID',
    },
    {
        name: 'Merchant Order ID',
        value: 'ENTITY_ORDER_ID',
    },
    {
        name: 'Merchant TXN ID',
        value: 'ENTITY_TXN_ID',
    },
    {
        name: 'RRN',
        value: 'RRN',
    },
    {
        name: 'Terminal ID',
        value: 'TERMINAL_ID',
    },
];

const TransactionsActions = ({
    data,
    statusData,
    fetchStatus,
    fetchData,
    fetchTxnError,
    getRefundTxnRequest,
    refundTxnData,
    resetRefunTxn,
    auth,
    raiseChargeBackRequest,
}) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setActionType(null);
        fetchTxnError({});
        resetRefunTxn();
    };
    return (
        <div className="userAction  multiItem">
            <button className="view" onClick={handleOpenActionPopup} />
            <Popup
                title={data.original.merchantName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <TransactionForm
                    auth={auth}
                    actionType={actionType}
                    data={data.original}
                    statusData={(statusData && statusData.details) || {}}
                    refundTxnData={
                        (refundTxnData && refundTxnData.details) || []
                    }
                    fetchStatus={fetchStatus}
                    getRefundTxnRequest={getRefundTxnRequest}
                    fetchData={fetchData}
                    fetchTxnError={fetchTxnError}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                    raiseChargeBackRequest={raiseChargeBackRequest}
                />
            </Popup>
        </div>
    );
};

const setMerchantFilter = (
    fieldsList,
    underlyingMerchant,
    entityList,
    selectedAggregator,
    handleSearchEnd
) => {
    const { merchants = [] } = entityList;
    if (selectedAggregator) {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId') {
                element.props.data = merchants;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }

    if (underlyingMerchant.length) {
        fieldsList.forEach(element => {
            if (
                element.name === 'merchantId' ||
                element.name === 'merchantName'
            ) {
                element.props.data = underlyingMerchant;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }
    return fieldsList;
};

const setAggregatorFilter = (fieldsList, entityList, handleSearchEnd) => {
    const { aggregator = [] } = entityList;
    if (aggregator.length) {
        fieldsList.forEach(element => {
            if (element.name === 'aggregatorId') {
                element.props.data = aggregator;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }
    return fieldsList;
};

// eslint-disable-next-line max-statements
const Transactions = props => {
    const {
        transactionData,
        actions,
        // staticData,
        loader: { showLoader },
        merchantData,
        auth,
    } = props;

    const {
        error,
        tableData,
        isLoading,
        pagination,
        generatedFile,
        activeReports,
        statusData,
        refundTxnData,
    } = transactionData;

    const { entityList } = merchantData;
    // const { underlyingMerchant } = staticData;
    const [filterData, setFilterData] = useState({ isLive: true });

    // useState for DropDown
    const [searchKey, setSearchKey] = useState('TRANSACTION_ID');
    const [searchValue, setSearchValue] = useState('');

    const { userLevel, associatedEntityId } = auth.userDetails;

    const columns = useMemo(
        () => [
            { header: 'Terminal ID', accessor: 'terminalId' },
            { header: 'Merchant Name', accessor: 'merchantName' },
            { header: 'Merchant ID', accessor: 'merchantId' },
            { header: 'Merchant TXN ID', accessor: 'orderId' },
            { header: 'Date & Time', accessor: 'transactionDateAndTime' },
            { header: 'Amount', accessor: 'transactionAmount' },
            { header: 'Payment mode', accessor: 'paymentMode' },
            { header: 'Type', accessor: 'transactionType' },
            { header: 'Instrument Information', accessor: 'instrumentInfo' },
            { header: 'Status', accessor: 'transactionStatus' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const selectedAggregator = useRef(null);

    const handleViewDownloads = () => {
        setShowFilter(true);
    };

    const handleCloseViewDownloads = () => {
        setShowFilter(false);
    };

    const handleAggregatorSelect = useCallback(
        entityCode => {
            selectedAggregator.current = entityCode;
            if (!entityCode) {
                // used to rerender so all merchant visible
                setFilterData({
                    createdOn: filterData.createdOn,
                });
                return;
            }
            actions.fetchEntityHierarchyRequest(
                entityCode,
                'LOWER_COMPLETE',
                'AGGREGATOR_TXN'
            );
        },
        [actions]
    );

    useEffect(() => {
        // get all aggregator
        actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT);
        // add onchange listener to aggregator
        filterFieldList.forEach(filter => {
            if (filter.name === 'aggregatorId') {
                filter.props.onChange = handleAggregatorSelect;
            }
        });
    }, [actions, handleAggregatorSelect]);

    useEffect(() => {
        if (generatedFile.isSuccess) {
            setShowFilter(true);
            setShowDownloadPopup(false);
        }
        return () => {
            actions.generateReportError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatedFile.isSuccess]);

    // remove filters for specific users
    useEffect(() => {
        // if not admin remove aggregator
        if (userLevel && userLevel !== 'ADMIN') {
            filterFieldList = filterFieldList.filter(
                filter => filter.name !== 'aggregatorId'
            );
        }
        // if merchant remove merchant
        if (userLevel && userLevel === 'MERCHANT') {
            filterFieldList = filterFieldList.filter(
                filter => filter.name !== 'merchantId'
            );
        }
        // if not admin remove rollback and pay delayed
        if (userLevel && userLevel !== 'ADMIN') {
            filterFieldList = filterFieldList.map(filter => {
                if (filter.name === 'transactionTypes') {
                    filter.props = {
                        options: (() => {
                            const options = [];
                            for (const key in TRANSACTION_TYPE) {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        TRANSACTION_TYPE,
                                        key
                                    )
                                ) {
                                    const value = TRANSACTION_TYPE[key];
                                    if (
                                        userLevel !== 'ADMIN' &&
                                        ADMIN_ONLY_TRANSACTION_TYPE.includes(
                                            value
                                        )
                                    ) {
                                        continue;
                                    }
                                    options.push({
                                        name: value,
                                        value: key,
                                    });
                                }
                            }
                            return options;
                        })(),
                        labelField: 'name',
                        valueField: 'value',
                    };
                }

                return filter;
            });
        }
    }, [userLevel]);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageIndex,
            };
            if (
                filterData.createdOn &&
                Object.keys(filterData.createdOn).length &&
                userLevel
            ) {
                // for aggregator show split txn in default view
                if (userLevel === 'AGGREGATOR' && !filterData.merchantIds) {
                    actions.fetchTransactionsRequest({
                        ...data,
                        ...filterData,
                        merchantIds: null,
                    });
                } else {
                    actions.fetchTransactionsRequest({
                        ...data,
                        ...filterData,
                    });
                }
            }
            setPageSize(pageSize);
            setSearchValue('');
        },
        [
            actions,
            associatedEntityId,
            filterData,
            userLevel,
        ]
    );

    useEffect(() => {
        if (userLevel) {
            // for aggregator request only when auth data is present
            fetchData({ pageIndex: 0, pageSize: 10 });
        }
    }, [userLevel]);

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const handleSearchSubmit = () => {
        if (searchValue) {
            actions.fetchTransactionsRequest({
                searchKey,
                searchValue,
            });
        } else {
            actions.fetchTransactionsRequest({
                createdOn: filterData.createdOn,
            });
        }
    };

    const handleSearchEnd = (value, entityType) => {
        const type = entityType === 'MERCHANT_NAME' ? 'MERCHANT' : entityType;
        const filtered =
            entityList[type.toLowerCase()]?.filter(item => {
                const key = entityType === 'MERCHANT' ? 'entityCode' : 'name';
                return item[key]?.toLowerCase().includes(value.toLowerCase());
            }) || [];

        const data = {
            entityName: ['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType)
                ? value
                : '',
            entityCode: !['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType)
                ? value
                : '',
        };

        if (filtered.length === 0 && value.length >= 3) {
            actions.fetchEntityListRequest(type, data);
        }
    };

    let filters = setMerchantFilter(
        filterFieldList,
        entityList.merchant || [],
        entityList,
        selectedAggregator.current,
        handleSearchEnd
    );
    filters = setAggregatorFilter(filterFieldList, entityList, handleSearchEnd);

    const filterSubmitHandler = filterValues => {
        const { aggregatorId, merchantId, merchantName } = filterValues;
        delete filterValues.merchantIds;
        let merchantIds = [];
        if (aggregatorId) {
            merchantIds.push(aggregatorId);
        }
        if (merchantId) {
            merchantIds.push(merchantId);
        }
        if (merchantName) {
            merchantIds.push(merchantName);
        }
        if (merchantIds.length) {
            merchantIds = [...new Set(merchantIds)];
            filterValues.merchantIds = merchantIds;
        }
        setFilterData({ ...filterValues, isLive: filterData.isLive });
        setIsResetPage(true);
    };

    const liveModeChange = values => {
        setFilterData({ ...filterData, isLive: !filterData.isLive });
    };

    return (
        <div className="transactions-wrapper">
            <Table
                tableTitle="Transaction View"
                filterActionTitle="View Downloads"
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                onClickTableAction={handleViewDownloads}
                tableSearch={
                    <div className="search">
                        <div>
                            <FormElems.Switch
                                name="isLive"
                                labelField="label"
                                id="test-live"
                                options={[
                                    {
                                        label: 'Live Mode',
                                        value: 'live',
                                    },
                                ]}
                                valueField="value"
                                handleChange={val => liveModeChange(val)}
                                isChecked={filterData.isLive}
                            />
                        </div>
                        <div className="search custom-search-wrapper">
                            <FormElems.Select
                                name="searchKey"
                                placeholder="Select Search Key"
                                id="search-key"
                                wrapperClass="settlement-type-field"
                                data={searchKeyList}
                                labelField="name"
                                valueField="value"
                                value={searchKey}
                                handleChange={val => setSearchKey(val)}
                            />
                            <TableSearch
                                search={searchValue}
                                setSearch={setSearchValue}
                                handleSearchSubmit={handleSearchSubmit}
                                placeholder={'Enter Search Value'}
                            />
                        </div>
                    </div>
                }
                userActions={data => (
                    <TransactionsActions
                        data={data}
                        statusData={statusData}
                        refundTxnData={refundTxnData}
                        fetchData={fetchData}
                        fetchStatus={actions.fetchTransactionsStatusRequest}
                        fetchTxnError={actions.fetchTransactionsStatusError}
                        resetRefunTxn={actions.resetRefunTxn}
                        getRefundTxnRequest={actions.getRefundTxnRequest}
                        auth={auth}
                        raiseChargeBackRequest={actions.raiseChargeBackRequest}
                    />
                )}
                additionalActions={() => (
                    <DownloadFile
                        filterData={filterData}
                        tableData={tableData}
                        actions={actions}
                        showDownloadPopup={showDownloadPopup}
                        setShowDownloadPopup={setShowDownloadPopup}
                        generateData={generatedFile}
                    />
                )}
                tableActionPopup={
                    <Popup
                        title="Download Status"
                        showCloseIcon
                        showOverlay
                        showFilter={showFilter}
                        closePopup={handleCloseViewDownloads}
                    >
                        <ViewDownloadStatus data={activeReports.reports} />
                    </Popup>
                }
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        maximumNights={6}
                        fieldsList={filters}
                        onSubmit={filterValues => {
                            filterSubmitHandler(filterValues);
                        }}
                        onReset={resetValue => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...resetValue,
                            });
                            selectedAggregator.current = null;
                            setIsResetPage(true);
                        }}
                    />
                }
            />
        </div>
    );
};

const mapStateToProps = ({
    auth,
    transactionData,
    loader,
    staticData,
    merchantData,
}) => ({
    auth,
    transactionData,
    loader,
    staticData,
    merchantData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchTransactionsRequest,
            fetchTransactionsStatusRequest,
            generateReportRequest,
            generateReportError,
            fetchTransactionsStatusError,
            setEntityDataSuccess,
            fetchEntityListRequest,
            fetchEntityHierarchyRequest,
            getRefundTxnRequest,
            resetRefunTxn,
            raiseChargeBackRequest,
        },
        dispatch
    ),
});

Transactions.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    transactionData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
};

TransactionsActions.propTypes = {
    data: PropTypes.object,
    auth: PropTypes.object,
    statusData: PropTypes.object,
    refundTxnData: PropTypes.object,
    roleStatus: PropTypes.string,
    fetchData: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchTxnError: PropTypes.func,
    getRefundTxnRequest: PropTypes.func,
    resetRefunTxn: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
